import { useCallback, useEffect, useRef, useState } from "react";
import { DeviceEventEmitter } from "react-native";

import { fetchRoomGroup } from "@/components/http/events";
import { isGrouped } from "./rooms";

// Emitted after a room is added, renamed or deleted so open screens reload.
export const ROOMS_CHANGED = "rooms_changed";

const EMPTY = { primary: null, rooms: [], loading: false, loadedKey: null };

// The primary and rooms of `event`'s group (empty for a standalone event).
// `loaded` turns true once the group of the current event has been fetched.
const useRoomGroup = (event) => {
  const [group, setGroup] = useState(EMPTY);
  const eventRef = useRef(event);
  eventRef.current = event;
  const key = [
    event?.slug,
    event?.room_of || "",
    (Array.isArray(event?.room_slugs) ? event.room_slugs : []).join(","),
  ].join("|");

  const reload = useCallback(async () => {
    const current = eventRef.current;
    if (!current?.slug || !isGrouped(current)) {
      setGroup({ ...EMPTY, loadedKey: key });
      return;
    }
    setGroup((g) => ({ ...g, loading: true }));
    const result = await fetchRoomGroup(current);
    if (eventRef.current?.slug === current.slug) {
      setGroup({ ...result, loading: false, loadedKey: key });
    }
  }, [key]);

  useEffect(() => {
    reload();
  }, [reload]);

  useEffect(() => {
    const sub = DeviceEventEmitter.addListener(ROOMS_CHANGED, () => reload());
    return () => sub && sub.remove();
  }, [reload]);

  return { ...group, loaded: group.loadedKey === key, reload };
};

export default useRoomGroup;
